import { createHead } from '@unhead/vue/client'

const unhead = createHead({
	init: [
		{
			titleTemplate: (title) => {
				if (title) {
					return `${title} · MTG Deck Builder`
				} else {
					return 'MTG Deck Builder by Iristorm Design'
				}
			},
		},
	],
})

export default unhead
